export const mock = (path: string, useMock = false) => {
  if (process.env.NODE_ENV === 'production') {
    return path;
  } else {
    if (useMock) {
      console.log(`USING MOCK [${path}]`, 'warn', undefined, 3);
      if (path.startsWith('/')) {
        return 'http://localhost:3333' + path;
      } else {
        return 'http://localhost:3333/' + path;
      }
    } else {
      return path;
    }
  }
};
